import React from 'react';
import { useTranslation } from 'react-i18next';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useServiceAccess } from '../../context/ServiceAccessContext';
import { useAuth } from '../../context/AuthContext';
import { serviceSlugForPath } from '../../config/serviceAccess';

const ServiceAccessGate: React.FC = () => {
  const { canAccess, ready } = useServiceAccess();
  const { isIndividual } = useAuth();
  const { t } = useTranslation('common');
  const location = useLocation();

  const serviceSlug = serviceSlugForPath(location.pathname);

  if (!serviceSlug) return <Outlet />;

  if (!ready) {
    return (
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '60vh',
          color: '#94a3b8',
        }}
      >
        {t('labels.loading')}
      </div>
    );
  }

  if (!canAccess(serviceSlug)) {
    if (isIndividual) {
      return <Navigate to="/plans" replace state={{ locked: serviceSlug }} />;
    }
    return <Navigate to="/home" replace state={{ from: location.pathname }} />;
  }

  return <Outlet />;
};

export default ServiceAccessGate;